document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const burger = document.querySelector(".header__burger");
  const nav = document.querySelector(".header__nav");

  if (!header) return;

  let ticking = false;

  function handleScroll() {
    if (window.scrollY > header.offsetHeight) {
      header.classList.add("header--sticky");
    } else {
      header.classList.remove("header--sticky");
    }
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  function updateNavPosition() {
    const h = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");

    if (!nav) return;

    if (window.innerWidth <= 1200) {
      nav.style.top = h + "px";
      nav.style.height = `calc(100vh - ${h}px)`;
    } else {
      nav.style.top = "";
      nav.style.height = "";
    }
  }
  updateNavPosition();
  window.addEventListener("load", updateNavPosition);

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(updateNavPosition).observe(header);
  }

  let resizeTimeout;

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateNavPosition, 150);
  });
  
  if (burger && nav) {
    burger.addEventListener("click", function () {
      updateNavPosition();

      const isOpen = nav.classList.toggle("is-open");
      burger.classList.toggle("is-active");
      burger.setAttribute("aria-expanded", isOpen);

      document.body.style.overflow = isOpen ? "hidden" : "";
    });
  }
  if (window.innerWidth <= 1200) {
    const hasChildren = header.querySelectorAll(".menu-item-has-children > a");
    hasChildren.forEach(function (link) {
      link.addEventListener("click", function (e) {
        const megaMenu = link.nextElementSibling;
        if (megaMenu && megaMenu.classList.contains("mega-menu")) {
          e.preventDefault();
          const isOpen = megaMenu.classList.toggle("mega-menu--open");
          link.parentElement.classList.toggle("is-open", isOpen);
        }
      });
    });
  }
});